export const projectsTableData = [
    {
      img: "/img/logo-xd.svg",
      name: "Material XD Version",
      members: [
        { img: "/img/team-1.jpeg", name: "Romina Hadid" },
        { img: "/img/team-2.jpeg", name: "Ryan Tompson" },
        { img: "/img/team-3.jpeg", name: "Jessica Doe" },
        { img: "/img/team-4.jpeg", name: "Alexander Smith" },
      ],
      budget: "$14,000",
      completion: 60,
    },
    {
      img: "/img/logo-atlassian.svg",
      name: "Add Progress Track",
      members: [
        { img: "/img/team-2.jpeg", name: "Ryan Tompson" },
        { img: "/img/team-4.jpeg", name: "Alexander Smith" },
      ],
      budget: "$3,000",
      completion: 10,
    },
    {
      img: "/img/logo-slack.svg",
      name: "Fix Platform Errors",
      members: [
        { img: "/img/team-3.jpeg", name: "Jessica Doe" },
        { img: "/img/team-1.jpeg", name: "Romina Hadid" },
      ],
      budget: "Not set",
      completion: 100,
    },
    {
      img: "/img/logo-spotify.svg",
      name: "Launch our Mobile App",
      members: [
        { img: "/img/team-4.jpeg", name: "Alexander Smith" },
        { img: "/img/team-3.jpeg", name: "Jessica Doe" },
        { img: "/img/team-2.jpeg", name: "Ryan Tompson" },
        { img: "/img/team-1.jpeg", name: "Romina Hadid" },
      ],
      budget: "$20,500",
      completion: 100,
    },
    {
      img: "/img/logo-jira.svg",
      name: "Add the New Pricing Page",
      members: [{ img: "/img/team-4.jpeg", name: "Alexander Smith" }],
      budget: "$500",
      completion: 25,
    },
    {
      img: "/img/logo-invision.svg",
      name: "Redesign New Online Shop",
      members: [
        { img: "/img/team-1.jpeg", name: "Romina Hadid" },
        { img: "/img/team-4.jpeg", name: "Alexander Smith" },
      ],
      budget: "$2,000",
      completion: 40,
    },
  ];
  
  export default projectsTableData;
  